import React from 'react'
import PropTypes from 'prop-types'
import TitleBar from '../Layout/titleBar'
import { Row, Col } from 'react-flexbox-grid'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import IconButton from '@material-ui/core/IconButton'
import { EditOutlined } from '@material-ui/icons'
import Button from '@material-ui/core/Button'
import Switch from '@material-ui/core/Switch'
import { withStyles } from '@material-ui/core/styles';
import NumberFormat from 'react-number-format'
import SeleccionSucursales from './seleccionSucursales';

import './styles.css'

const styles = theme => ({
    colorSwitchBase: {
        color: '#9FA1A4',
        '&$colorChecked': {
            color: '#F57922',
            '& + $colorBar': {
                backgroundColor: '#FABC90',
                opacity: '1'
            },
        },
    },
    colorBar: {
        backgroundColor: '#000',
        opacity: '0.12'
    },
    colorChecked: {
        color: '#F57922',
    },
    colorDisabled: {
        color: '#E4E6E8',
        '&$colorChecked': {
            color: '#FABC90',
            '& + $colorBar': {
                backgroundColor: '#FABC90',
                opacity: '1'
            },
        },
    }
});
class UsuarioEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            usuarioActivo: false,
            listaNegra: null,
            listaBlanca: null,
            listaNegraActive: false,
            listaBlancaActive: false,
            sucursalesUsuario: [],
            sucursales: []
        }

    }


    handleChangeSwitch = (e) => {
        this.setState({
            usuarioActivo: e.target.checked,
        })
    }

    handleChangeSwitchListaNegra = (e) => {
        this.setState({
            listaNegraActive: e.target.checked,
            listaBlancaActive: e.target.checked && this.state.listaBlancaActive ? false : this.state.listaBlancaActive,
        })
    }

    handleChangeSwitchListaBlanca = (e) => {
        this.setState({
            listaBlancaActive: e.target.checked,
            listaNegraActive: e.target.checked && this.state.listaNegraActive ? false : this.state.listaNegraActive,
        })
    }

    handleChangeSucursales = (sucursales) => {
        this.setState({
            sucursalesUsuario: sucursales
        })
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            usuarioActivo: nextProps.usuario.activo,
            listaNegra: nextProps.usuario.cliente.listaNegra,
            listaNegraActive: nextProps.usuario.cliente.listaNegraActive,
            listaBlanca: nextProps.usuario.cliente.listaBlanca,
            listaBlancaActive: nextProps.usuario.cliente.listaBlancaActive,
            sucursalesUsuario: nextProps.usuario.sucursalUsuarios,
            sucursales: nextProps.sucursales
        }, () => { this.render() })
    }


    render() {

        // Validación para nombre y apellido para evitar escritura de números
        let handleKeyPress = (event) => {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const invalidCharsRegex = /[0-9\W_]/;

            if (invalidCharsRegex.test(keyValue)) {
                event.preventDefault();
            }
        };

        let tipoRol = "";
        tipoRol = (this.props.usuario.tipoRol === 1) ? 'interno' : tipoRol
        tipoRol = (this.props.usuario.tipoRol === 2) ? 'externo' : tipoRol

        const { classes } = this.props;

        return (
            <div className='crearEditarUsuario'>

                {/* menú superior */}
                {this.props.usuario.id !== null ? (
                    <TitleBar
                        title={`${this.props.usuario.nombre} ${this.props.usuario.apellido}`}
                        type='edicionUsuario'  /** tiene cancelar */
                        handleOnBack2={this.props.handleOnCancel}
                        showSearch={false}
                    />
                ) : (
                    <TitleBar
                        title={((this.props.usuario.id === null) ? 'Nuevo' : 'Editar') + ' usuario ' + tipoRol}
                        type='createArticulo'  /** tiene cancelar y guardar*/
                        handleOnBack={this.props.handleOnCancel}
                        handleOnSave={this.props.handleOnSave}
                        showSearch={false}
                    />
                )}

                {/**panel usuario interno */}
                {(this.props.usuario.tipoRol === 1) &&
                    <Row>
                        <Col md={8}>
                            <Paper className='myBox' style={{ margin: '0px', padding: '0px' }}>
                                <div className='content no-margin title'>
                                    <div style={{ height: '34px', paddingTop: '7px' }}>Datos personales</div>
                                    {!this.props.editDatos && <IconButton
                                        color='default'
                                        onClick={() => this.props.setEditDatos(true)}
                                        style={{ marginLeft: 'auto', padding: '5px', background: '#46C082', borderRadius: '10px', color: '#FFFFFF' }}
                                    >
                                        <EditOutlined />
                                    </IconButton>}
                                </div>
                                <div className='content no-margin'>
                                    <Row>
                                        <Col md={6}>
                                            <TextField className='myInput'
                                                label='Usuario'
                                                name='nombreUsuario'
                                                fullWidth
                                                required={this.props.editDatos}
                                                disabled={!this.props.editDatos}
                                                error={(this.props.error && this.props.error.nombreUsuario) && (this.props.usuario.nombreUsuario === '')}
                                                helperText={((this.props.error && this.props.error.nombreUsuario) && (this.props.usuario.nombreUsuario === '')) ? this.props.error.nombreUsuario : ""}
                                                value={this.props.usuario.nombreUsuario}
                                                onChange={this.props.handleOnChange}
                                            />
                                        </Col>

                                        <Col md={6}>
                                            <TextField className='myInput'
                                                label='Rol'
                                                select
                                                required={this.props.editDatos}
                                                error={this.props.error && this.props.error.rol}
                                                helperText={(this.props.error && this.props.error.rol) ? this.props.error.rol : ""}
                                                name='rol'
                                                fullWidth
                                                disabled={!this.props.editDatos}
                                                value={this.props.usuario.rol}
                                                onChange={this.props.handleOnChange}
                                                InputLabelProps={{ shrink: this.props.usuario.rol !== "" && this.props.usuario.rol !== null }}
                                            >
                                                {
                                                    this.props.roles.map(option => (
                                                        <MenuItem key={"rol" + option.descripcion} value={option.descripcion}>
                                                            {option.descripcion}
                                                        </MenuItem>))
                                                }
                                            </TextField>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={6}>
                                            <TextField className='myInput'
                                                label='Nombre'
                                                fullWidth
                                                required={this.props.editDatos}
                                                disabled={!this.props.editDatos}
                                                error={(this.props.error && this.props.error.nombre) && (this.props.usuario.nombre === '')}
                                                helperText={((this.props.error && this.props.error.nombre) && (this.props.usuario.nombre === '')) ? this.props.error.nombre : ""}
                                                name='nombre'
                                                onKeyPress={handleKeyPress}
                                                value={this.props.usuario.nombre}
                                                onChange={this.props.handleOnChange}
                                            />
                                        </Col>
                                        <Col md={6}>
                                            <TextField className='myInput'
                                                label='Apellido'
                                                fullWidth
                                                required={this.props.editDatos}
                                                disabled={!this.props.editDatos}
                                                error={(this.props.error && this.props.error.apellido) && (this.props.usuario.apellido === '')}
                                                helperText={((this.props.error && this.props.error.apellido) && (this.props.usuario.apellido === '')) ? this.props.error.apellido : ""}
                                                name='apellido'
                                                onKeyPress={handleKeyPress}
                                                value={this.props.usuario.apellido}
                                                onChange={this.props.handleOnChange}
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={6}>
                                            <TextField className='myInput'
                                                label='Email'
                                                fullWidth
                                                required={this.props.editDatos}
                                                disabled={!this.props.editDatos}
                                                error={(this.props.error && this.props.error.email && (!this.props.valido))}
                                                helperText={(this.props.error && this.props.error.email && (!this.props.valido)) ? this.props.error.email : ""}
                                                name='email'
                                                value={this.props.usuario.email}
                                                onChange={this.props.handleOnChange}
                                            />
                                        </Col>

                                    </Row>
                                    {this.props.editDatos && (
                                        <Row>
                                            <Col md={6}>
                                            </Col>
                                            <Col md={6}>
                                                <div class="buttons-footer">
                                                    <Button className="btnSecundarioFlat" onClick={() => { this.props.setEditDatos(false); this.props.getPreUsuario(); }}>CANCELAR</Button>
                                                    <Button className="btnPrincipalFlat" onClick={() => {
                                                        this.props.handleOnSave();
                                                    }}>GUARDAR</Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                </div>
                            </Paper>
                        </Col>
                        <Col md={4}>
                            <Paper className='myBox' style={{ margin: '0px 0px 32px 0px', padding: '0px' }}>
                                <div className='content no-margin title'>
                                    <div style={{ height: '34px', paddingTop: '7px' }}>Seguridad</div>
                                    {!this.props.editSeguridad && <IconButton
                                        color='default'
                                        onClick={() => this.props.setEditSeguridad(true)}
                                        style={{ marginLeft: 'auto', padding: '5px', background: '#46C082', borderRadius: '10px', color: '#FFFFFF' }}
                                    >
                                        <EditOutlined />
                                    </IconButton>}
                                </div>
                                <div className='content no-margin'>
                                    <Row>
                                        <Col md={12}>
                                            Cuenta Activa
                                        </Col>
                                        <Col md={12}>
                                            <Switch
                                                checked={this.state.usuarioActivo}
                                                onChange={(e) => this.handleChangeSwitch(e)}
                                                disabled={!this.props.editSeguridad}
                                                classes={{
                                                    switchBase: classes.colorSwitchBase,
                                                    checked: classes.colorChecked,
                                                    bar: classes.colorBar,
                                                    disabled: classes.colorDisabled
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                    {this.props.editSeguridad && (
                                        <Row>
                                            <Col md={6}>
                                            </Col>
                                            <Col md={6}>
                                                <div class="buttons-footer">
                                                    <Button className="btnSecundarioFlat" onClick={() => { this.props.setEditSeguridad(false); this.props.getPreUsuario(); }}>CANCELAR</Button>
                                                    <Button className="btnPrincipalFlat" onClick={() => { this.props.setEditSeguridad(false); this.props.setListasActivo(this.state.listaBlancaActive, this.state.listaNegraActive, this.state.usuarioActivo); }}>GUARDAR</Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                </div>
                            </Paper>
                            <Paper className='myBox' style={{ margin: '0px 0px 32px 0px', padding: '0px' }}>
                                <div className='content no-margin title'>
                                    <div style={{ height: '34px', paddingTop: '7px' }}>Sucursales</div>
                                    {!this.props.editSucursales && <IconButton
                                        color='default'
                                        onClick={() => this.props.setEditSucursales(true)}
                                        style={{ marginLeft: 'auto', padding: '5px', background: '#46C082', borderRadius: '10px', color: '#FFFFFF' }}
                                    >
                                        <EditOutlined />
                                    </IconButton>}
                                </div>
                                <div className='content no-margin'>
                                    {!this.props.editSucursales && (<SeleccionSucursales listadoSucursales={this.state.sucursales} sucursalesUsuario={this.state.sucursalesUsuario} edit={true} />)}
                                    {this.props.editSucursales && (<SeleccionSucursales listadoSucursales={this.state.sucursales} sucursalesUsuario={this.state.sucursalesUsuario} edit={false} handleChangeSucursales={this.handleChangeSucursales} />)}
                                    {this.props.editSucursales && (
                                        <Row>
                                            <Col md={6}>
                                            </Col>
                                            <Col md={6}>
                                                <div class="buttons-footer">
                                                    <Button className="btnSecundarioFlat" onClick={() => { this.props.setEditSucursales(false); this.props.getPreUsuario(); }}>CANCELAR</Button>
                                                    <Button className="btnPrincipalFlat" onClick={() => { this.props.setEditSucursales(false); this.props.setSucursales(this.state.sucursalesUsuario); }}>GUARDAR</Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                </div>
                            </Paper>
                        </Col>
                    </Row>
                }

                {/**panel usuario externo */}
                {(this.props.usuario.tipoRol === 2) && <React.Fragment>
                    <Row>
                        <Col md={8}>
                            <Paper className='myBox' style={{ margin: '0px', padding: '0px' }}>
                                <div className='content no-margin title'>
                                    <div style={{ height: '34px', paddingTop: '7px' }}>Datos personales</div>
                                    {!this.props.editDatos && <IconButton
                                        color='default'
                                        onClick={() => this.props.setEditDatos(true)}
                                        style={{ marginLeft: 'auto', padding: '5px', background: '#46C082', borderRadius: '10px', color: '#FFFFFF' }}
                                    >
                                        <EditOutlined />
                                    </IconButton>}
                                </div>
                                <div className='content no-margin'>
                                    <Row>
                                        <Col md={6}>
                                            <TextField className='myInput'
                                                label='Apellido'
                                                fullWidth
                                                disabled={!this.props.editDatos}
                                                error={(this.props.error && this.props.error.apellido) && (this.props.usuario.apellido === '')}
                                                helperText={((this.props.error && this.props.error.apellido) && (this.props.usuario.apellido === '')) ? this.props.error.apellido : ""}
                                                name='apellido'
                                                value={this.props.usuario.apellido}
                                                onChange={this.props.handleOnChange}
                                            />
                                        </Col>
                                        <Col md={6}>
                                            <TextField className='myInput'
                                                label='Nombre'
                                                fullWidth
                                                disabled={!this.props.editDatos}
                                                error={(this.props.error && this.props.error.nombre) && (this.props.usuario.nombre === '')}
                                                helperText={((this.props.error && this.props.error.nombre) && (this.props.usuario.nombre === '')) ? this.props.error.nombre : ""}
                                                name='nombre'
                                                value={this.props.usuario.nombre}
                                                onChange={this.props.handleOnChange}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <NumberFormat
                                                className='myInput'
                                                customInput={TextField}
                                                label="DNI"
                                                fullWidth
                                                name='cliente.dni'
                                                disabled={!this.props.editDatos}
                                                value={this.props.usuario.cliente.dni}
                                                decimalScale={0}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalSeparator={false}
                                                thousandSeparator={'.'}
                                                isAllowed={({ value }) => value <= 99999999}
                                                onValueChange={this.props.setDNI}
                                            />
                                            {/*<TextField className='myInput'
                                                disabled={!this.props.editDatos}                    
                                                label='DNI'
                                                fullWidth
                                                name='cliente.dni'
                                                value={this.props.usuario.cliente.dni}
                                                onChange={this.props.handleOnChange}
                                    />*/}
                                        </Col>
                                        <Col md={6}>
                                            <TextField className='myInput'
                                                disabled={!this.props.editDatos}
                                                label='Teléfono'
                                                fullWidth
                                                name='phoneNumber'
                                                value={this.props.usuario.phoneNumber}
                                                onChange={this.props.handleOnChange}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <TextField className='myInput'
                                                disabled
                                                label='Email'
                                                fullWidth
                                                error={this.props.error && this.props.error.email}
                                                helperText={(this.props.error && this.props.error.email) ? this.props.error.email : ""}
                                                name='email'
                                                value={this.props.usuario.email}
                                                onChange={this.props.handleOnChange}
                                            />
                                        </Col>

                                    </Row>
                                    {this.props.editDatos && (
                                        <Row>
                                            <Col md={6}>
                                            </Col>
                                            <Col md={6}>
                                                <div class="buttons-footer">
                                                    <Button className="btnSecundarioFlat" onClick={() => { this.props.setEditDatos(false); this.props.getPreUsuario(); }}>CANCELAR</Button>
                                                    <Button className="btnPrincipalFlat" onClick={() => {
                                                        this.props.handleOnSave();
                                                    }}>GUARDAR</Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                </div>
                            </Paper>
                        </Col>
                        <Col md={4}>
                            <Paper className='myBox' style={{ margin: '0px', padding: '0px' }}>
                                <div className='content no-margin title'>
                                    <div style={{ height: '34px', paddingTop: '7px' }}>Seguridad</div>
                                    {!this.props.editSeguridad && <IconButton
                                        color='default'
                                        onClick={() => this.props.setEditSeguridad(true)}
                                        style={{ marginLeft: 'auto', padding: '5px', background: '#46C082', borderRadius: '10px', color: '#FFFFFF' }}
                                    >
                                        <EditOutlined />
                                    </IconButton>}
                                </div>
                                <div className='content no-margin'>
                                    <Row>
                                        <Col md={6}>
                                            <Row>
                                                <Col md={12}>
                                                    Cliente en lista negra
                                                </Col>
                                                <Col md={12}>
                                                    <Switch
                                                        checked={this.state.listaNegraActive}
                                                        onChange={(e) => this.handleChangeSwitchListaNegra(e)}
                                                        disabled={!this.props.editSeguridad}
                                                        classes={{
                                                            switchBase: classes.colorSwitchBase,
                                                            checked: classes.colorChecked,
                                                            bar: classes.colorBar,
                                                            disabled: classes.colorDisabled
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={6}>
                                            <Row>
                                                <Col md={12}>
                                                    Cliente en lista blanca
                                                </Col>
                                                <Col md={12}>
                                                    <Switch
                                                        checked={this.state.listaBlancaActive}
                                                        onChange={(e) => this.handleChangeSwitchListaBlanca(e)}
                                                        disabled={!this.props.editSeguridad}
                                                        classes={{
                                                            switchBase: classes.colorSwitchBase,
                                                            checked: classes.colorChecked,
                                                            bar: classes.colorBar,
                                                            disabled: classes.colorDisabled
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={6}>
                                            <Row>
                                                <Col md={12}>
                                                    Cuenta Activa
                                                </Col>
                                                <Col md={12}>
                                                    <Switch
                                                        checked={this.state.usuarioActivo}
                                                        onChange={(e) => this.handleChangeSwitch(e)}
                                                        disabled={!this.props.editSeguridad}
                                                        classes={{
                                                            switchBase: classes.colorSwitchBase,
                                                            checked: classes.colorChecked,
                                                            bar: classes.colorBar,
                                                            disabled: classes.colorDisabled
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>

                                    {this.props.editSeguridad && (
                                        <Row>
                                            <Col md={6}>
                                            </Col>
                                            <Col md={6}>
                                                <div class="buttons-footer">
                                                    <Button className="btnSecundarioFlat" onClick={() => { this.props.setEditSeguridad(false); this.props.getPreUsuario(); }}>CANCELAR</Button>
                                                    <Button className="btnPrincipalFlat" onClick={() => {
                                                        this.props.setEditSeguridad(false);
                                                        this.props.setListasActivo(this.state.listaBlancaActive, this.state.listaNegraActive, this.state.usuarioActivo);
                                                    }}>GUARDAR</Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                </div>
                            </Paper>
                        </Col>
                    </Row>
                </React.Fragment>
                }
            </div>
        )
    }
}

UsuarioEdit.propTypes = {
    usuario: PropTypes.object.isRequired,
    handleOnChange: PropTypes.func.isRequired,
    handleOnSave: PropTypes.func.isRequired,
    handleOnCancel: PropTypes.func.isRequired,
    setActivo: PropTypes.func.isRequired,
    setListaBlanca: PropTypes.func.isRequired,
    setListaNegra: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
}

UsuarioEdit.defaultProps = {
    catalogos: []
}

export default withStyles(styles)(UsuarioEdit)